import Dialog from 'components/ReusableComponents/Dialog'
import useClickOut from 'hooks/useClickOut'
import { useRef } from 'react'

import CloseIcon from './CloseIcon'
import styles from './ConversationBubble.module.scss'

const ImageGallery = ({ hideGallery, imgUrl }) => {
  const ref = useRef()

  useClickOut(ref, hideGallery)

  return (
    <Dialog>
      <div className={styles.gallery} ref={ref}>
        <button className={styles.galleryCloseButton} onClick={hideGallery}>
          <CloseIcon fill="white" width={28} height={28} />
        </button>
        {/* eslint-disable-next-line */}
        <img src={imgUrl} />
      </div>
    </Dialog>
  )
}

export default ImageGallery
